<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <b-container>
    <b-row>
      <b-col
        class="d-flex justify-content-center align-items-center"
        sm="12"
        md="6"
      >
        <b-img :src="require('@/assets/images/pages/coming-soon.svg')" />
      </b-col>
      <b-col
        sm="12"
        md="6"
      >
        <b-card>
          <b-card-title>
            Crear nuevo usuario
          </b-card-title>
          <validation-observer ref="formValidation">
            <b-form @submit.prevent="validateForm()">
              <b-form-group label="Nombre">
                <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
                >
                  <b-form-input v-model="user.name" autocomplete="off" type="text" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input v-model="user.email" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group :label="$t('phone')">
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                >
                  <b-form-input v-model="user.phone" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Rol">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-select
                    v-model="user.role_name"
                    :options="roles"
                    text-field="label"
                    value-field="key"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-overlay
                :show="loading"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
              >
                <b-button type="submit">
                  {{ $t('add', { type: '' }) }}
                </b-button>
              </b-overlay>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      loading: false,
      user: {
        name: null,
        email: null,
        phone: null,
        supplier: null,
        role_name: 'admin',
        scoped_roles: [],
        role_resource_id: null,
      },
      roles: [
        {
          key: 'admin',
          label: 'Administrador',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('suppliers', ['suppliers']),
    ...mapGetters('branches', ['branches']),
  },

  created() {
    this.fetchSuppliers()
  },

  methods: {
    ...mapActions('branches', ['fetchBranches']),
    ...mapActions('auth', ['createCustomer']),
    ...mapActions('suppliers', ['fetchSuppliers']),
    ...mapActions('users', ['createUser']),
    validateForm() {
      this.$refs.formValidation.validate().then(success => {
        if (success) {
          this.loading = true
          if (this.user.role_name === 'supplier_admin') {
            this.user.role_resource_id = this.user.supplier
          }
          this.createUser(this.user)
            .then(() => {
              const roleName = this.roles.find(
                role => role.key === this.user.role_name,
              )?.label
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('typeCreated', {
                    type: roleName,
                  }),
                  icon: 'EditIcon',
                  variant: 'success',
                },
              })
            })
            .then(() => {
              this.$router.push({ name: 'users' })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
